import {useState} from "react";

import {reloadPoolStatisticsThunk} from "../../redux/poolStatisticsThunk";
import {useRevaDispatch} from "../../redux/revaHooks";
import PoolStatisticsPanel from "./PoolStatisticsPanel";
import {StatisticsToggleButton} from "./startPageWidgets";
import ValuationsTable from "./ValuationsTable";

interface PoolTabProps {
    className?: string;
}

/**
 * #19113: POOL tab of the start page ("Auftragspool") — the unassigned valuation pool. The current
 * age-distribution statistics live behind a stats toggle in the top-right control cluster (left of the
 * reload button, see {@link StatisticsToggleButton}/{@link TabControlCluster}): hidden and unloaded
 * until the user opens them; the panel loads them on mount (a no-op once initialized). The
 * valuation list below always loads on its own.
 */
export default function PoolTab({className}: PoolTabProps) {
    const dispatch = useRevaDispatch();
    const [showStats, setShowStats] = useState(false);

    return (
        <div id="poolTab" className={className}>
            <ValuationsTable
                tab="POOL"
                statsToggle={<StatisticsToggleButton active={showStats} onToggle={() => setShowStats((s) => !s)} />}
                statsPanel={showStats ? <PoolStatisticsPanel className="mb-6" /> : null}
                onReloadStats={showStats ? () => void dispatch(reloadPoolStatisticsThunk()) : undefined}
            />
        </div>
    );
}
